const getAdditionalEnrollmentInfoQuery = (version, params) =>
    `query EnrollmentQuery {
      getEnrollmentResolvers_${version}(${params.join(', ')}) {
        enrollmentData {
          licensingConfiguration {
            licensingInfo
            gradeAvailabilityInfo {
              key
              measures
            }
          }
        }
      }
    }`;
export default getAdditionalEnrollmentInfoQuery;
